export default __webpack_public_path__ + "static/media/mav-stats.fc2d1c69.svg";